import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { Spinner } from '@/components/Elements';
import { MainLayout } from '@/components/Layout';
import { lazyImport } from '@/utils/lazyImport';
import { ModalProvider as FlowchartNodeDetailModalProvider } from '@/features/insightTemplates/components/ViewFlowDetailContext';
import { NewInsightProvider } from '@/features/insightTemplates/components/NewInsightContext';
import { InsightFlowChart } from '@/features/InsightFlowChart';
import { SettingsLayout } from '@/features/settings/components/SettingsLayout';
import { InsightChatProvider } from '@/features/insights/components/InsightChatContext';
import { DASHBOARD_ENABLED } from '@/config';
import posthog from 'posthog-js';
import { KeyDefinitionDetail } from '@/features/settings/routes/KeyDefinitionDetail';

// const { Apps } = lazyImport(() => import('@/features/apps'), 'Apps');
// const { CreateNewApp } = lazyImport(
//   () => import('@/features/apps'),
//   'CreateNewApp'
// );
// const { EditApp } = lazyImport(() => import('@/features/apps'), 'EditApp');
const { ChatApp } = lazyImport(() => import('@/features/apps'), 'ChatApp');
const { ChatAppDemo } = lazyImport(
  () => import('@/features/insights'),
  'ChatAppDemo'
);
const { GetNewInsight } = lazyImport(
  () => import('@/features/apps'),
  'GetNewInsight'
);
const { InsightTemplates } = lazyImport(
  () => import('@/features/insightTemplates'),
  'InsightTemplates'
);
const { CreateNewInsight } = lazyImport(
  () => import('@/features/insightTemplates'),
  'CreateNewInsight'
);
const { ScheduleTemplate } = lazyImport(
  () => import('@/features/insightTemplates'),
  'ScheduleTemplate'
);
const { ScheduledInsights } = lazyImport(
  () => import('@/features/scheduledInsights'),
  'ScheduledInsights'
);
const { MyProfile } = lazyImport(
  () => import('@/features/settings'),
  'MyProfile'
);
const { UserManagement } = lazyImport(
  () => import('@/features/settings'),
  'UserManagement'
);

// const { DataSource } = lazyImport(
//   () => import('@/features/dataSource'),
//   'DataSource'
// );
// const { AddNewSource } = lazyImport(
//   () => import('@/features/dataSource'),
//   'AddNewSource'
// );
// const { EditDataSource } = lazyImport(
//   () => import('@/features/dataSource'),
//   'EditDataSource'
// );
// const { Executions } = lazyImport(
//   () => import('@/features/executions'),
//   'Executions'
// );
const { Integrations } = lazyImport(
  () => import('@/features/settings'),
  'Integrations'
);
const { DataCatalog } = lazyImport(
  () => import('@/features/settings'),
  'DataCatalog'
);
const { IntegrationDetail } = lazyImport(
  () => import('@/features/settings'),
  'IntegrationDetail'
);
const { DictionaryDetail } = lazyImport(
  () => import('@/features/settings'),
  'DictionaryDetail'
);
const { PetaReports } = lazyImport(
  () => import('@/features/petaReports'),
  'PetaReports'
);

const { Reports } = lazyImport(() => import('@/features/reports'), 'Reports');

const { Explore } = lazyImport(() => import('@/features/explore'), 'Explore');
const { Dashboard } = lazyImport(
  () => import('@/features/dashboard'),
  'Dashboard'
);

const { Playground } = lazyImport(
  () => import('@/features/playground'),
  'Playground'
);

const { RecommendationTester } = lazyImport(
  () => import('@/features/playground'),
  'RecommendationTester'
);

const { MetricPickerTester } = lazyImport(
  () => import('@/features/playground'),
  'MetricPickerTester'
);

const { TablePickerTester } = lazyImport(
  () => import('@/features/playground'),
  'TablePickerTester'
);

const { ColumnPickerTester } = lazyImport(
  () => import('@/features/playground'),
  'ColumnPickerTester'
);

const { MessageSelector } = lazyImport(
  () => import('@/features/playground'),
  'MessageSelector'
);

const { RecommendationDetails } = lazyImport(
  () => import('@/features/playground'),
  'RecommendationDetails'
);

const { KDAutoConfig } = lazyImport(
  () => import('@/features/playground'),
  'KDAutoConfig'
);

const App = () => {
  return (
    <MainLayout>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            {/* <Spinner size="xl" /> */}
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

// const AppsPage = () => {
//   return (
//     <Apps>
//       <Suspense
//         fallback={
//           <div className="h-full w-full flex items-center justify-center">
//             <Spinner size="xl" />
//           </div>
//         }
//       >
//         <Outlet />
//       </Suspense>
//     </Apps>
//   );
// };

// const CreateAppPage = () => {
//   return (
//     <CreateNewApp>
//       <Suspense
//         fallback={
//           <div className="h-full w-full flex items-center justify-center">
//             <Spinner size="xl" />
//           </div>
//         }
//       >
//         <Outlet />
//       </Suspense>
//     </CreateNewApp>
//   );
// };

// const EditAppPage = () => {
//   return (
//     <EditApp>
//       <Suspense
//         fallback={
//           <div className="h-full w-full flex items-center justify-center">
//             <Spinner size="xl" />
//           </div>
//         }
//       >
//         <Outlet />
//       </Suspense>
//     </EditApp>
//   );
// };

const InsightTemplatesPage = () => {
  return (
    <FlowchartNodeDetailModalProvider>
      <InsightTemplates>
        <Suspense
          fallback={
            <div className="h-full w-full flex items-center justify-center">
              <Spinner size="xl" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </InsightTemplates>
    </FlowchartNodeDetailModalProvider>
  );
};

const CreateNewInsightPage = () => {
  return (
    <NewInsightProvider>
      <FlowchartNodeDetailModalProvider>
        <CreateNewInsight>
          <Suspense
            fallback={
              <div className="h-full w-full flex items-center justify-center">
                <Spinner size="xl" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </CreateNewInsight>
      </FlowchartNodeDetailModalProvider>
    </NewInsightProvider>
  );
};
const ScheduleInsightPage = () => {
  return (
    <NewInsightProvider>
      <FlowchartNodeDetailModalProvider>
        <ScheduleTemplate>
          <Suspense
            fallback={
              <div className="h-full w-full flex items-center justify-center">
                <Spinner size="xl" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </ScheduleTemplate>
      </FlowchartNodeDetailModalProvider>
    </NewInsightProvider>
  );
};
const GetNewInsightPage = () => {
  return (
    <GetNewInsight>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </GetNewInsight>
  );
};

const InsightFlowchartPage = () => {
  return (
    <FlowchartNodeDetailModalProvider>
      <InsightFlowChart>
        <Suspense
          fallback={
            <div className="h-full w-full flex items-center justify-center">
              <Spinner size="xl" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </InsightFlowChart>
    </FlowchartNodeDetailModalProvider>
  );
};

const ScheduledInsightsPage = () => {
  return (
    <ScheduledInsights>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </ScheduledInsights>
  );
};

// const DataSourcePage = () => {
//   return (
//     <DataSource>
//       <Suspense
//         fallback={
//           <div className="h-full w-full flex items-center justify-center">
//             <Spinner size="xl" />
//           </div>
//         }
//       >
//         <Outlet />
//       </Suspense>
//     </DataSource>
//   );
// };
// const AddNewSourcePage = () => {
//   return (
//     <AddNewSource>
//       <Suspense
//         fallback={
//           <div className="h-full w-full flex items-center justify-center">
//             <Spinner size="xl" />
//           </div>
//         }
//       >
//         <Outlet />
//       </Suspense>
//     </AddNewSource>
//   );
// };
// const EditDataSourcePage = () => {
//   return (
//     <EditDataSource>
//       <Suspense
//         fallback={
//           <div className="h-full w-full flex items-center justify-center">
//             <Spinner size="xl" />
//           </div>
//         }
//       >
//         <Outlet />
//       </Suspense>
//     </EditDataSource>
//   );
// };

// const ExecutionPage = () => {
//   return (
//     <Executions>
//       <Suspense
//         fallback={
//           <div className="h-full w-full flex items-center justify-center">
//             <Spinner size="xl" />
//           </div>
//         }
//       >
//         <Outlet />
//       </Suspense>
//     </Executions>
//   );
// };

const IntegrationsPage = () => {
  return (
    <SettingsLayout>
      <Integrations>
        <Suspense
          fallback={
            <div className="h-full w-full flex items-center justify-center">
              <Spinner size="xl" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </Integrations>
    </SettingsLayout>
  );
};
const MyProfilePage = () => {
  return (
    <MyProfile>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </MyProfile>
  );
};
const UserManagementPage = () => {
  return (
    <SettingsLayout>
      <UserManagement>
        <Suspense
          fallback={
            <div className="h-full w-full flex items-center justify-center">
              <Spinner size="xl" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </UserManagement>
    </SettingsLayout>
  );
};
const DataCatalogPage = () => {
  return (
    // <SettingsLayout>
    <DataCatalog>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </DataCatalog>
    // </SettingsLayout>
  );
};
const DictionaryDetailPage = () => {
  return (
    <DictionaryDetail>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </DictionaryDetail>
  );
};
const KeyDefinitionDetailPage = () => {
  return (
    <KeyDefinitionDetail>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </KeyDefinitionDetail>
  );
};
const IntegrationDetailPage = () => {
  return (
    <SettingsLayout>
      <IntegrationDetail>
        <Suspense
          fallback={
            <div className="h-full w-full flex items-center justify-center">
              <Spinner size="xl" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </IntegrationDetail>
    </SettingsLayout>
  );
};

const UserIntegrationDetailPage = () => {
  return (
    <IntegrationDetail>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </IntegrationDetail>
  );
};

const ChatPage = () => {
  return (
    <FlowchartNodeDetailModalProvider>
      <ChatApp />
    </FlowchartNodeDetailModalProvider>
  );
};
const ChatAppPage = () => {
  return (
    <InsightChatProvider>
      <FlowchartNodeDetailModalProvider>
        <ChatAppDemo />
      </FlowchartNodeDetailModalProvider>
    </InsightChatProvider>
  );
};

const PetaReportsPage = () => {
  return (
    <InsightChatProvider>
      <FlowchartNodeDetailModalProvider>
        <PetaReports />
      </FlowchartNodeDetailModalProvider>
    </InsightChatProvider>
  );
};

const ReportsPage = () => {
  return (
    <InsightChatProvider>
      <FlowchartNodeDetailModalProvider>
        <Reports />
      </FlowchartNodeDetailModalProvider>
    </InsightChatProvider>
  );
};

const ExplorePage = () => {
  return (
    <InsightChatProvider>
      <FlowchartNodeDetailModalProvider>
        <Explore />
      </FlowchartNodeDetailModalProvider>
    </InsightChatProvider>
  );
};

const DashboardPage = () => {
  return (
    <Dashboard>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </Dashboard>
  );
};

const PlaygroundPage = () => {
  return <Playground />;
};

const RecommendationTesterPage = () => {
  return <RecommendationTester />;
};

const MetricPickerTesterPage = () => {
  return <MetricPickerTester />;
};

const TablePickerTesterPage = () => {
  return <TablePickerTester />;
};

const ColumnPickerTesterPage = () => {
  return <ColumnPickerTester />;
};

const MessageSelectorPage = () => {
  return <MessageSelector />;
};

const RecommendationDetailsPage = () => {
  return <RecommendationDetails />;
};

const KDAutoConfigPage = () => {
  return <KDAutoConfig />;
};

export const protectedRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <Navigate to="/explore" replace />,
        enableRouterInIframe: true,
      },
      {
        path: 'explore',
        element: <ReportsPage />,
        enableRouterInIframe: true,
      },
      {
        path: 'explore/:exploreId',
        element: <ReportsPage />,
        enableRouterInIframe: true,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
        posthogFlag: 'dashboards',
      },
      {
        path: 'dashboard/:dashboardId',
        element: <DashboardPage />,
      },
      {
        path: 'home',
        element: <ChatPage />, // not needed
        role: 'admin',
      },
      {
        path: 'deep-dive',
        element: <ExplorePage />,
        posthogFlag: 'deep-dive',
        // role: 'admin',
        enableRouterInIframe: true,
      },
      {
        path: 'deep-dive/:exploreId',
        element: <ExplorePage />,
        posthogFlag: 'deep-dive',
        role: 'admin',
        enableRouterInIframe: true,
      },
      {
        path: 'discover',
        element: <ChatAppPage />,
        posthogFlag: 'discover',
        role: 'admin',
      },
      {
        path: 'discover/:conversationId',
        element: <ChatAppPage />,
        posthogFlag: 'discover',
        role: 'admin',
      },
      {
        path: 'peta-reports',
        element: <PetaReportsPage />,
        posthogFlag: 'peta-reports',
        role: 'admin',
      },
      {
        path: 'peta-reports/:conversationId',
        element: <PetaReportsPage />,
        posthogFlag: 'peta-reports',
        role: 'admin',
      },
      {
        path: 'home/create-new-insight',
        element: <CreateNewInsightPage />, // not needed
        role: 'admin',
      },
      {
        path: 'home/get-new-insight',
        element: <GetNewInsightPage />, // not needed
        role: 'admin',
      },
      {
        path: 'templates',
        element: <InsightTemplatesPage />,
        posthogFlag: 'templates',
        role: 'admin',
      },
      {
        path: 'insight-templates/create-new-insight',
        element: <CreateNewInsightPage />, // not needed
        role: 'admin',
      },
      {
        path: 'insight-templates/insight/:insightId',
        element: <CreateNewInsightPage />, // not needed
        role: 'admin',
      },
      {
        path: 'home/insight/:insightId',
        element: <CreateNewInsightPage />, // not needed
        role: 'admin',
      },
      {
        path: 'home/get-new-insight/insight/:insightId',
        element: <CreateNewInsightPage />, // not needed
        role: 'admin',
      },
      {
        path: 'insight-templates/schedule-insight',
        element: <ScheduleInsightPage />, // not needed
        role: 'admin',
      },
      {
        path: 'scheduled-insights',
        element: <ScheduledInsightsPage />,
        role: 'admin',
      },
      {
        path: 'settings/integrations',
        element: <IntegrationsPage />,
        posthogFlag: 'settings-integrations',
        role: 'admin',
      },
      {
        path: 'my-profile',
        element: <MyProfilePage />,
      },
      {
        path: 'integrations/:integrationId',
        element: <UserIntegrationDetailPage />,
        // role: 'admin',
      },
      {
        path: 'settings/user-management',
        element: <UserManagementPage />,
        role: 'admin',
      },
      {
        path: 'data-catalog',
        element: <DataCatalogPage />,
        enableRouterInIframe: true,
        role: 'admin',
      },
      {
        path: 'data-catalog/:dataCatalogId',
        element: <DictionaryDetailPage />,
        enableRouterInIframe: true,
        role: 'admin',
      },
      {
        path: 'data-catalog/key-definition/:keyDefinitionId',
        element: <KeyDefinitionDetailPage />,
        enableRouterInIframe: true,
        role: 'admin',
      },
      // { path: 'settings/data-catalog', element: <DataCatalogPage /> },
      {
        path: 'settings/integrations/:integrationId',
        element: <IntegrationDetailPage />,
        posthogFlag: 'settings-integrations',
        role: 'admin',
      },

      {
        path: 'playground',
        element: <PlaygroundPage />,
        role: 'admin',
        children: [
          {
            path: 'recommendation',
            element: <RecommendationTesterPage />,
            role: 'admin',
          },
          {
            path: 'key-definition-picker',
            element: <MetricPickerTesterPage />,
            role: 'admin',
          },
          {
            path: 'table-picker',
            element: <TablePickerTesterPage />,
            role: 'admin',
          },
          {
            path: 'column-picker',
            element: <ColumnPickerTesterPage />,
            role: 'admin',
          },
          {
            path: 'recom-info/:conversationId/:messageId',
            element: <RecommendationDetailsPage />,
            role: 'admin',
          },
          {
            path: 'recom-info/:conversationId',
            element: <MessageSelectorPage />,
            role: 'admin',
          },
          {
            path: 'recom-info',
            element: <MessageSelectorPage />,
            role: 'admin',
          },
          {
            path: 'kd',
            element: <KDAutoConfigPage />,
            role: 'admin',
          },
        ],
      },
      // {
      //   path: 'settings/data-catalog/:dataCatalogId',
      //   element: <DictionaryDetailPage />,
      //   role: 'admin',
      // },
    ],
  },
  {
    path: '/app',
    children: [
      { path: 'insight/:executionId', element: <InsightFlowchartPage /> }, // not working
    ],
  },
  { path: '*', element: <Navigate to="/explore" /> },
];
